export enum CommunicationState {
  Passed,
  Running,
  Coming,
}
